var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-count"},[_c('h2',{staticClass:"vue-count__title section-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"entry-content"},[_c('p',[_vm._v("This count is: "),_c('strong',[_vm._v(_vm._s(_vm.count))])])]),_c('button',{staticClass:"vue-block__btn btn btn--green",on:{"click":_vm.inc}},[_vm._v("Incrament!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }